import { CULTURE_TOKEN } from '@servicetitan/culture';
import { useDependencies } from '@servicetitan/react-ioc';
import { useMemo } from 'react';
export const usePhoneMaskWithExtension = () => {
    const [{ PhoneFormat: { PhoneMask = '?999999999999999' } = {} }] = useDependencies(CULTURE_TOKEN);
    return useMemo(() => PhoneMask.replace(/\?/g, ''), [PhoneMask]);
};
//# sourceMappingURL=use-phone-mask-with-extension.js.map